export default "__VITE_ASSET__DUpNs9Jz__"